// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.activities/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.activities/route.tsx");
}
// REMIX HMR END

import { activityListExample } from '@commural/shared-resources/schemas/business/Activity.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import { Link } from '@remix-run/react';
import clsx from 'clsx';
import invariant from 'tiny-invariant';
import { z } from 'zod';
import { ScrollView } from '~/components/ScrollView';
import { getCapitalized } from '~/utils.server';
import cn from './Activities.module.css';
const TITLE = 'activity log';
const Tabs = ['all', 'posts', 'events', 'campaigns', 'topics'];
const typeConverter = {
  all: 'all',
  posts: 'post',
  events: 'event',
  campaigns: 'campaign',
  topics: 'topic'
};
const TabsEnum = z.enum(Tabs);
_c = TabsEnum;
export async function loader({
  request,
  context
}) {
  const title = await getCapitalized(TITLE, request, context);
  const url = new URL(request.url);
  const result = TabsEnum.safeParse(url.searchParams.get('tab') ?? 'all');
  const tab = result.success ? result.data : 'all';
  const type = typeConverter[tab];
  const activityList = type === 'all' ? activityListExample : activityListExample.filter(el => el.type === type);
  return {
    title,
    tab,
    activityList
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE
};
export default function Index() {
  _s();
  const {
    tab,
    activityList
  } = useLoaderDataWithCache();
  return <ScrollView>
      <section>
        <header>
          <nav>
            <ul className={cn.Tabs}>
              {Tabs.map(el => <li key={el}>
                  <Link className={clsx({
                [cn.Active]: el === tab
              })} to={`?tab=${el}`} replace>

                    {el}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </header>
        <main>
          <ul>
            {activityList.map(el => <ActivityListItem key={el.id} activity={el} />)}
          </ul>
        </main>
      </section>
    </ScrollView>;
}
_s(Index, "owF1/AtuSG1kp7kYTWB/+Nvr5i4=", false, function () {
  return [useLoaderDataWithCache];
});
_c2 = Index;
function ActivityListItem({
  activity
}) {
  const ContentComponent = getContentComponent(activity.type);
  return <li className={cn.ActivityListItem}>
      <ContentComponent activity={activity} />
    </li>;
}
_c3 = ActivityListItem;
function getContentComponent(type) {
  switch (type) {
    case 'post':
      return PostContent;
    case 'event':
      return EventContent;
    case 'campaign':
      return CampaignContent;
    case 'topic':
      return TopicContent;
  }
}
function PostContent({
  activity
}) {
  const {
    payload
  } = activity;
  invariant(payload.type === 'post', 'type needs to be post');
  return <>
      <img className={cn.Avatar} src={activity.userAvatarURL} alt={activity.userName} />

      <div>{activity.userName}</div>
    </>;
}
_c4 = PostContent;
function EventContent({
  activity
}) {
  const {
    payload
  } = activity;
  invariant(payload.type === 'event', 'type needs to be event');
  return <>
      <img className={cn.Avatar} src={activity.userAvatarURL} alt={activity.userName} />

      <div>{activity.userName}</div>
    </>;
}
_c5 = EventContent;
function CampaignContent({
  activity
}) {
  const {
    payload
  } = activity;
  invariant(payload.type === 'campaign', 'type needs to be campaign');
  return <>
      <img className={cn.Avatar} src={activity.userAvatarURL} alt={activity.userName} />

      <div>{activity.userName}</div>
    </>;
}
_c6 = CampaignContent;
function TopicContent({
  activity
}) {
  const {
    payload
  } = activity;
  invariant(payload.type === 'topic', 'type needs to be topic');
  return <>
      <img className={cn.Avatar} src={activity.userAvatarURL} alt={activity.userName} />

      <div>{activity.userName}</div>
    </>;
}
_c7 = TopicContent;
var _c, _c2, _c3, _c4, _c5, _c6, _c7;
$RefreshReg$(_c, "TabsEnum");
$RefreshReg$(_c2, "Index");
$RefreshReg$(_c3, "ActivityListItem");
$RefreshReg$(_c4, "PostContent");
$RefreshReg$(_c5, "EventContent");
$RefreshReg$(_c6, "CampaignContent");
$RefreshReg$(_c7, "TopicContent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;